import { BRAND } from "@/lib/site";

export default function OurStory() {
  return (
    <section className="bg-white py-20 md:py-24" data-testid="our-story-section">
      <div className="fg-container grid items-center gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <img
            src={BRAND.vanUrl}
            alt="The Flowgrid Plumbing branded van — your local Sydney plumber"
            className="aspect-square w-full rounded-xl border border-slate-200 bg-white object-contain p-4 shadow-md"
            loading="lazy"
          />
        </div>
        <div className="md:col-span-6">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Our <span className="text-blue-600">Story</span>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            At FlowGrid Plumbing, we provide premium plumbing services across
            Sydney, built on quality workmanship, reliability, and genuine
            customer care. With years of industry experience, we take pride in
            delivering practical, long-lasting solutions while making the
            process simple and stress-free for our clients.
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            We believe great plumbing is about more than fixing problems —
            it&apos;s about building trust. That&apos;s why we focus on honest
            advice, clear communication, and workmanship completed to the
            highest standard. Whether it&apos;s a simple repair, emergency
            call-out, or major installation, you can rely on FlowGrid Plumbing
            to get the job done right.
          </p>
        </div>
      </div>
    </section>
  );
}
